export default [
  {
    path: '/purple-phone/contacts',
    name: 'purple-phone-contacts',
    component: () => import('@/views/purplePhone/PurplePhoneContacts.vue'),
    meta: {
      protected: true,
      pageTitle: 'Purple Phone - Contacts',
    },
  },
  {
    path: '/purple-phone/numbers',
    name: 'purple-phone-numbers',
    component: () => import('@/views/purplePhone/PurplePhoneNumbers.vue'),
    meta: {
      protected: true,
      pageTitle: 'Purple Phone - Numbers',
    },
  },
  {
    path: '/purple-phone/numbers/:id',
    name: 'purple-phone-number-details',
    component: () => import('@/views/purplePhone/PurplePhoneNumberDetails.vue'),
    meta: {
      protected: true,
      pageTitle: 'Purple Phone - Number Details',
    },
  },
  {
    path: '/purple-phone/calls',
    name: 'purple-phone-calls',
    component: () => import('@/views/purplePhone/PurplePhoneCalls.vue'),
    meta: {
      protected: true,
      pageTitle: 'Purple Phone - Number Details',
    },
  },
  {
    path: '/purple-phone/calls/:id',
    name: 'purple-phone-call-details',
    component: () => import('@/views/purplePhone/PurplePhoneCallDetails.vue'),
    meta: {
      protected: true,
      pageTitle: 'Purple Phone - Number Details',
    },
  }
]
